import React from 'react';

import { ArrowDownPillIcon, TopSortPillIcon } from '~/src/dash/components/icons/pill-icons';
import {
  IListViewTableColumnInfo,
  IListViewTableColumns,
} from '~/src/dash/components/tables/ListViewTable/common';

export type SortIconKey = 'arrow_down' | 'arrow_up';

export interface ISortByItem {
  key: string;
  iconKey?: SortIconKey;
}

export const extractSortsFromColumns = (orderByKeys: string[], columns: IListViewTableColumns) => {
  const sorts: IListViewTableColumnInfo[] = [];
  orderByKeys.forEach((key) => {
    sorts.push(columns[key]);
  });
  return sorts;
};

interface ISortIconProps {
  color: string;
  iconKey?: SortIconKey;
}

export const SortIcon = ({ color, iconKey }: ISortIconProps) => {
  switch (iconKey) {
    case 'arrow_down':
      return (
        <ArrowDownPillIcon
          color={color}
          style={{
            height: '12px',
            paddingTop: '3px',
          }}
        />
      );
    case 'arrow_up':
      return (
        <TopSortPillIcon
          color={color}
          style={{
            height: '12px',
            paddingTop: '3px',
          }}
        />
      );
    default:
      return <></>;
  }
};
